
import './App.css';
import {useState,useEffect,useRef } from "react";
import io from 'socket.io-client'
import axios from 'axios';
import Header from './modules/header/header';
import Footer from './modules/footer/footer';
import Auth from './pages/register/auth';
import Register from './pages/register/register';
import Reload from './pages/register/reload';
import Datings from './pages/dating/dating';
import Chat from './pages/chat/chat';
import Settings from './pages/settings/settings';
import Profile from './pages/profile/profile';
import ModeratedPhoto from './pages/register/moderatedphoto';
import { useAuthLocalStorage } from './modules/useLocalStore';
import Popup from './modules/popup/popup';
import NotificationSound from './img/zvuk.mp3';
import Notification from './modules/notification/notification';


function App() {
  const [stage, setStage] = useState(0);
  const [page, setPage] = useState(0);
  const PageOnline = useRef(0);
  const [activePhoto, setActivePhoto] = useState(null);
  const [allChats,setAllChats] = useState([]);
  const [message,setUserMessage] = useState([]);
  const [like, setLike] = useState([]);
  const [mutual, setMutual] = useState([]);
  const audioPlayer = useRef(null);
  const hasEmitted = useRef(false);
  const ThisIsLoad = useRef(false);
  const socketRef = useRef(null);
  const Moderated = useRef(true);

  const chats = useRef(allChats);
  const [hasInteracted, setHasInteracted] = useState(false);

  const [count, setCount] = useState(0);

    const addNewNotification = (id,name,type) => {
        setCount(prevCount => prevCount + 1);
        let message = '';
        switch (type) {
          case 'like':
              message = `${name} поставил(а) Вам лайк!`;
              break;
          case 'submitlike':
              message = `У Вас с ${name} взаимная симпатия!`;
              break;
          case 'message':
              message = `${name} написал(а) Вам новое сообщение!`;
              break;
          default:
              message = `Новое увдомление от ${name}`;
              break;
        }
        const newNotification = {
            image: id,
            message: message,
            type: type
        };
        Notification.addNotification(newNotification);
        playSound();
    };
  
useEffect(() => {
    const interactionHandler = () => {
      setHasInteracted(true);
    };

    window.addEventListener('click', interactionHandler);
    window.addEventListener('keydown', interactionHandler);
    window.addEventListener('touchstart', interactionHandler);

    return () => {
      window.removeEventListener('click', interactionHandler);
      window.removeEventListener('keydown', interactionHandler);
      window.removeEventListener('touchstart', interactionHandler);
    };
  }, []);

  function playSound() {
    if(hasInteracted == true) audioPlayer.current.play();    
  }
  const [myProfile, setMyProfile] = useState({
    info: {like: 0, likeall: 0, notice: false, menuopen: false, likeopen: false, profile: null, popup: null}
  });
 
  const { getToken, removeToken, saveToken } = useAuthLocalStorage();
  const activeAcc = useRef(null);
  const token = getToken();
  function bufferToBase64(buffer) {
    let binary = '';
    buffer.forEach(byte => {
        binary += String.fromCharCode(byte);
    });
    return window.btoa(binary);
  }
  useEffect(() => {
     const queryParams = new URLSearchParams(window.location.search);
     const logintoken = queryParams.get('loginfast');
     if(logintoken !== null)
     {
      saveToken(logintoken);
      setStage(1);
      setPage(2);
     }
    
     
     
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
        try {
           if(token !== null)
            {
              setStage(1);
            }
            if(stage === 0 || token === null) return;
            PopupOpen(21);
            ThisIsLoad.current = false;
            const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getProfile`;
            const config = {
                headers: {
                    Authorization: "Bearer " + token
                }
            };

            const response = await axios.post(url, {}, config);
            if(!response.data.error)
            {
                const prof = response.data;
                const text = prof.disc ?? '';
                const hobby = prof.hobby !== null ? prof.hobby.split(',') : [];
                setMyProfile(prevState => ({
                    ...prevState,
                    token: token,
                    userid: prof.id,
                    login: prof.login,
                    name: prof.name,
                    day: prof.day,
                    sex: prof.sex,
                    month: prof.month,
                    year: prof.year,
                    city: prof.city,
                    target: prof.target,
                    text: text,
                    money: prof.money,
                    vip: prof.vip,
                    sendselect: null,
                    activeChat: null,
                    limitmessage: prof.limitmessage,
                    photo: prof.photo,
                    hobby: hobby,
                    info: { like: prof.likeCount, likeall: prof.submitLike, notice: false, menuopen: false, likeopen: false, profile: null, popup: 21, profileactive: prof.profileactive }
                }));
                if(!prof.photo)
                {
                  Moderated.current = false;
                }
                else
                {
                  const moderatedObjects = prof.photo.filter(item => item.moderated === 1);
                  if (moderatedObjects.length > 0) {
                      Moderated.current = true;
                  } else {
                      Moderated.current = false;
                  }
                }
                ThisIsLoad.current = true;
                exitPopup();
                const chatUrl = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getChats`;
                const chatConfig = {
                    headers: {
                        Authorization: "Bearer " + token
                    }
                };
                const chatResponse = await axios.post(chatUrl, {}, chatConfig);

                if (chatResponse.data.like === true) {
                    setAllChats(chatResponse.data.date);
                    
                } 
            }
        } catch (error) {
            console.error("Ошибка при получении профиля: ", error);
            removeToken();
            setStage(0);
            setPage(1);
            removeProfile();
            exitPopup();
        }
    };

    fetchProfile();
}, [stage, token]);

  const changeStage = (newStage) => {
    setStage(newStage);
  };
  const removeProfile = () =>{
    setMyProfile({
        info: {like: 0, likeall: 0, notice: false, menuopen: false, likeopen: false, profile: null, popup: null}
    });
  }
  const exitPopup = () => {
      setMyProfile(prevState => ({
          ...prevState,
          info: {
              ...prevState.info,
              popup: null
          }
      }));
  }
  const changePage = (newPage) => {
    setPage(newPage);
  };
  const changeProfile = (newLike) => {
    setMyProfile(newLike);
  };
  const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
    useEffect(() => {
      chats.current = allChats;
      const filteredChats = chats.current.filter(chat => chat.lastM === 1 && chat.id_last !== myProfile.userid);
        if(filteredChats.length > 0)
        {
          
                setMyProfile(prevState => ({
                  ...prevState,
                  info: {
                      ...prevState.info,
                      notice: filteredChats.length
                  }
              }));
            

        } else {
          setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                notice: 0
            }}));
          }
  },[allChats]);

  useEffect(() => {
      activeAcc.current = myProfile.activeChat;
  },[myProfile.activeChat]);
  useEffect(() => {
      PageOnline.current = page;
  },[page]);
  useEffect(() => {
      if(token !== null && ThisIsLoad.current === true)
      {
      if (!hasEmitted.current) {
          
          socketRef.current = io(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}`, {
              reconnection: true,
              reconnectionAttempts: 150,
              reconnectionDelay: 500,
              reconnectionDelayMax: 5000,
              transports: ['websocket', 'polling'],
          });
          
          hasEmitted.current = true;
        }
        socketRef.current.on('connect', data => {
          console.log('connect');
          socketRef.current.emit('setToken',{token: token});
        });
        socketRef.current.on('connect_error', (error) => {
          console.error('Ошибка подключения:', error);
        });
         socketRef.current.on('disconnect', (reason) => {
            console.log('Socket disconnected:', reason);
            
          });
        socketRef.current.on('unlimit', data => {
            setMyProfile(prevState => ({
              ...prevState,
              limitmessage: 5
          }));
        });
        socketRef.current.on('addmoney', data => {
            setMyProfile(prevState => ({
              ...prevState,
              money: data.money,
              vip: data.vip
          }));
          PopupOpen(18);
        });
        
        socketRef.current.on('ToLike', data => {
          addNewNotification(data.photoid,data.name,data.type);
        });
        socketRef.current.on('DelitePhoto', data => {
          const deldata = parseInt(data.id);
            const updatedData = myProfile.photo.filter(item => item.id !== deldata);
            
            const updatedProfile = {
                  ...myProfile,
                  photo: updatedData
              };
              setMyProfile(updatedProfile);
              PopupOpen(25);
        });
        socketRef.current.on('ComplitePhoto', data => {
          const deldata = parseInt(data.id);
            const updatedData = myProfile.photo.map(item => {
              if (item.id === deldata) {
                return { ...item, moderated: 1 };
              } else {
                return item;
              }
            });
            const updatedProfile = {
                  ...myProfile,
                  photo: updatedData
              };
              setMyProfile(updatedProfile);
              if(Moderated.current === false) Moderated.current = true;
              if(myProfile.sex === 0) PopupOpen(28);
              else PopupOpen(26);
        });
        socketRef.current.on('NewChat', data => {
             const fetchData = async () => {
                const chatUrl = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getOneChats`;
                const chatConfig = {
                    headers: {
                        Authorization: "Bearer " + token
                    }
                };
                  try {
                  const chatResponse = await axios.post(chatUrl, {token: data.token}, chatConfig);

                  if (chatResponse.data.like === true) {
                     const chatWithNotificationToken = chats.current.find(chat => chat.token === chatResponse.data.date[0].token);
                      if (chatWithNotificationToken) {
                          const updatedChat = { ...chatWithNotificationToken, lastM: chatResponse.data.date[0].lastM, id_last: chatResponse.data.date[0].id_last, last: chatResponse.data.date[0].last};
                          const updatedChats = chats.current.map(chat => chat.token === data.token ? updatedChat : chat);
                          setAllChats(updatedChats);
                          
                      }
                      else
                      {
                          setAllChats(prevChats => [...prevChats, chatResponse.data.date[0]]);
                      }
                    }
                  } catch (error) {
                    console.error('Ошибка получения данных чата', error);
                  }
              };
              
              fetchData();
        });
       
          
          socketRef.current.on('MessageTo', data => {
            const chatWithNotificationToken = chats.current.find(chat => chat.token === data.token);
            if (chatWithNotificationToken) {
                let updatedChat;
                if(data.id_for !== myProfile.userid && activeAcc.current === chats.current.find(chat => chat.token === data.token)?.id) 
                {
                  
                     updatedChat = { ...chatWithNotificationToken, id_last: data.id_for, last: data.time ,lastM: 0};
                     const fetchData = async () => {
                        const chatUrl = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/readMessage`;
                        const chatConfig = {
                            headers: {
                                Authorization: "Bearer " + token
                            }
                        };
                        try {
                          const chatResponse = await axios.post(chatUrl, {token: data.token}, chatConfig);

                          
                          } catch (error) {
                            console.error('Ошибка получения данных чата', error);
                          }
                      };
                    
                    fetchData();
                    
                }
                else
                {
                    updatedChat = { ...chatWithNotificationToken, id_last: data.id_for, last: data.time ,lastM: 1};
                }
                const updatedChats = chats.current.map(chat => chat.token === data.token ? updatedChat : chat);

                setAllChats(updatedChats); // Обновляем состояние с новым массивом чатов
                if(data.id_for !== myProfile.userid) 
                {
                    if(activeAcc.current !== chats.current.find(chat => chat.token === data.token)?.id) 
                    {
                      addNewNotification(chats.current.find(chat => chat.token === data.token)?.photo,chats.current.find(chat => chat.token === data.token)?.name,'message');
                    }
                    else
                    {
                      if(PageOnline.current !== 2)
                      {
                          addNewNotification(chats.current.find(chat => chat.token === data.token)?.photo,chats.current.find(chat => chat.token === data.token)?.name,'message');
                      }
                    }
                  
                }
                if(activeAcc.current !== null)
                {
                    const chattok = chats.current.find(item => item.id === activeAcc.current)?.token;
                    if(data.token === chattok)
                    {
                        setUserMessage((prevMessages) => {
                            return [...prevMessages, data];
                        });
                    }
                }
            } else {
             
                 const fetchData = async () => {
                      const chatUrl = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getOneChats`;
                      const chatConfig = {
                          headers: {
                              Authorization: "Bearer " + token
                          }
                      };
                       try {
                        const chatResponse = await axios.post(chatUrl, {token: data.token}, chatConfig);

                        if (chatResponse.data.like === true) {
                          setAllChats(prevChats => [...prevChats, chatResponse.data.date[0]]);
                          
                        }
                        if(data.id_for !== myProfile.userid) 
                        {
                            
                             addNewNotification(chatResponse.data.date[0].photo, chatResponse.data.date[0].name,'message');
                     
                        }
                        
                        } catch (error) {
                          console.error('Ошибка получения данных чата', error);
                        }
                    };
                    
                    fetchData();
                    
            }
            
          
          });
      }
      return () => {
        if(socketRef.current) socketRef.current.disconnect();
    }
  },[token,ThisIsLoad.current]);
  return (
    <div className='flexse'>
    <div className='app'>
      <audio ref={audioPlayer} src={NotificationSound}/>
      <Popup myProfile={myProfile} setMyProfile={changeProfile} stage={stage} setStage={changeStage} page={page} setPage={changePage} setAllChats={setAllChats} allChats={allChats} setUserMessage={setUserMessage} message={message} setLike={setLike} like={like} setMutual={setMutual} mutual={mutual} socketRef={socketRef} />
      <div className='container'>
        { Moderated.current ? <Header stage={stage} setStage={changeStage} page={page} setPage={changePage} myProfile={myProfile} setMyProfile={changeProfile} setLike={setLike} like={like} setMutual={setMutual} mutual={mutual}/> : null }
        <Notification/>
      </div>
        {stage === 0 ? (
          (() => {
              switch (page) {
                  case 1:
                      return <div className='container'> <Auth myProfile={myProfile} setMyProfile={changeProfile} page={page} setPage={changePage} stage={stage} setStage={changeStage}/> </div>;
                  case 2:
                      return <div className='container'> <Reload page={page} setPage={changePage} /> </div>;
                  default:
                      return <div className='container'> <Register stage={stage} setStage={changeStage} myProfile={myProfile} setMyProfile={changeProfile}/> </div>;
              }
          })()
      ) : (
          (() => {
            if(Moderated.current)
            {
              switch (page) {
                  case 0:
                      return <div className='container'> <Datings myProfile={myProfile} setMyProfile={changeProfile} ThisIsLoad={ThisIsLoad} socketRef={socketRef}/> </div>;
                  case 1:
                      return  <div className='container'><Settings myProfile={myProfile} setMyProfile={changeProfile} activePhoto={activePhoto} setActivePhoto={setActivePhoto} page={page} setPage={changePage}/> </div>;
                  case 2:
                      return <Chat myProfile={myProfile} setMyProfile={changeProfile} activePhoto={activePhoto} setActivePhoto={setActivePhoto} setAllChats={setAllChats} allChats={allChats} setUserMessage={setUserMessage} message={message} playSound={playSound} socketRef={socketRef} setPage={changePage}/>;
                  case 5:  
                      return <Profile myProfile={myProfile} setMyProfile={changeProfile}/>;
                  default:
                      return null;
              }
            }
            else
            {
                return <div className='container'>
                  <ModeratedPhoto myProfile={myProfile} setMyProfile={changeProfile} ThisIsLoad={ThisIsLoad} socketRef={socketRef}/> 
                </div>;
            }
          })()
      )}
     
      </div>
        { stage === 0 && <Footer /> }
      </div>
  
  );
}

export default App;
